import React from "react";
import { useTranslation } from "react-i18next";
import {
  HeaderContainer,
  HeaderTitleGroup,
  HeaderStatusDot,
  HeaderMainTitle,
  HeaderActions,
  HeaderResetButton,
  HeaderCloseButton,
} from "./chatbot.styled";

const ChatHeader = ({ onMinimize, onResetContext, partnerName }) => {
  const { t } = useTranslation();
  const displayPartnerName = partnerName || t('common.partnerName', {
    partnerName: 'Petasense',
    defaultValue: '{{partnerName}}'
  });

  return (
    <HeaderContainer>
      <HeaderTitleGroup>
        <HeaderStatusDot />
        <div>
          <HeaderMainTitle>{t('chatbot.header.title', { partnerName: displayPartnerName })}</HeaderMainTitle>
        </div>
      </HeaderTitleGroup>
      <HeaderActions>
        <HeaderResetButton
          type="button"
          onClick={onResetContext}
          aria-label={t('chatbot.aria.resetChatContext')}
        >
          {t('chatbot.header.newChat')}
        </HeaderResetButton>
        <HeaderCloseButton
          type="button"
          onClick={onMinimize}
          aria-label={t('chatbot.aria.closeChat')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </HeaderCloseButton>
      </HeaderActions>
    </HeaderContainer>
  );
};

export default ChatHeader;
